import * as React from 'react';
import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';
function SvgSparkleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="m7.7 6.407-1.14.43c-.45.17-.45.81 0 .98l1.14.43c.82.31 1.46.95 1.77 1.77l.43 1.14c.17.45.81.45.98 0l.43-1.14c.31-.82.95-1.46 1.77-1.77l1.14-.43c.45-.17.45-.81 0-.98l-1.14-.43c-.82-.31-1.46-.95-1.77-1.77l-.43-1.14a.524.524 0 0 0-.98 0l-.43 1.14c-.31.82-.95 1.46-1.77 1.77ZM3.855 11.045l-.66.25c-.26.1-.26.47 0 .57l.66.25c.47.18.85.55 1.03 1.03l.25.66c.1.26.47.26.57 0l.25-.66c.18-.47.55-.85 1.03-1.03l.66-.25c.26-.1.26-.47 0-.57l-.66-.25c-.47-.18-.85-.55-1.03-1.03l-.25-.66a.306.306 0 0 0-.57 0l-.25.66c-.18.47-.55.85-1.03 1.03ZM2.713 4.723l-.551.203a.25.25 0 0 0 0 .468l.55.203c.396.144.707.455.85.85l.204.551a.25.25 0 0 0 .468 0l.203-.55c.144-.396.455-.707.85-.85l.551-.204a.25.25 0 0 0 0-.468l-.55-.203a1.422 1.422 0 0 1-.85-.85l-.204-.551a.25.25 0 0 0-.468 0l-.203.55a1.422 1.422 0 0 1-.85.85Z"
      />
    </svg>
  );
}
const SparkleIcon = forwardRef((props: IconProps, forwardedRef?: Ref<HTMLSpanElement>) => {
  return <Icon ref={forwardedRef} {...props} component={SvgSparkleIcon} />;
});
SparkleIcon.displayName = 'SparkleIcon';
export default SparkleIcon;
